type NumericBucketRule = {
  mantissas: readonly number[]
  minExp: number
  maxExp: number
  cap: number
}

// Mirrored in omnea-reports (cube/model/shared/numericBuckets.js), which compiles one Cube dimension
// per width. omnea-reports deploys first and this list must stay a subset of that one: a width offered
// here but missing there fails at query time, not at save time.
export const NUMERIC_BUCKET_RULE = { mantissas: [1, 2, 5], minExp: -2, maxExp: 7, cap: 10_000_000 } as const

const expand = ({ mantissas, minExp, maxExp, cap }: NumericBucketRule): readonly number[] => {
  const widths: number[] = []
  for (let exp = minExp; exp <= maxExp; exp++) {
    for (const mantissa of mantissas) {
      // toFixed, not `m * 10 ** exp`, or 2 × 10^-2 lands on 0.020000000000000004
      const width = Number((mantissa * 10 ** exp).toFixed(Math.max(0, -exp)))
      if (width <= cap) widths.push(width)
    }
  }
  return widths
}

export const NUMERIC_BUCKET_WIDTHS: readonly number[] = expand(NUMERIC_BUCKET_RULE)

export const isNumericBucketInterval = (value: number): boolean => NUMERIC_BUCKET_WIDTHS.includes(value)

// Cube member names admit only [a-zA-Z0-9_], so the decimal point becomes an underscore: 0.05 → 0_05.
export const bucketSlug = (w: number): string => String(w).replace('.', '_')

export const numericBucketMember = (stem: string, w: number): string => `${stem}_bucket_${bucketSlug(w)}`

export const numericProbeMembers = (stem: string) => ({
  min: `${stem}_min`,
  max: `${stem}_max`,
  recordCount: `${stem}_record_count`,
})
